import { render } from "./KPIPeriods.vue?vue&type=template&id=265ab653&scoped=true"
import script from "./KPIPeriods.vue?vue&type=script&lang=js"
export * from "./KPIPeriods.vue?vue&type=script&lang=js"

import "./KPIPeriods.vue?vue&type=style&index=0&id=265ab653&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265ab653"]])

export default __exports__